var exports = {
  "C1": "instructionsTextarea__RQUSjc",
  "vN": "assignAgentInfo__d4sVvL",
  "JA": "formRow__gdnY0X",
};

module.exports = exports;
